/**
 * Chrome 升级后会声称支持原生 HLS，video.js 若走原生路径容易黑屏/CORS。
 * 有 MSE 时强制走 VHS / contrib-hls；仅 iOS Safari 等无 MSE 时回退原生。
 */
export function isMseSupported() {
  return !!(window.MediaSource || window.WebKitMediaSource);
}

export function getHlsTechOptions() {
  const usePlugin = isMseSupported();
  return {
    html5: {
      vhs: {
        overrideNative: usePlugin,
      },
      hls: {
        overrideNative: usePlugin,
      },
      nativeAudioTracks: !usePlugin,
      nativeVideoTracks: !usePlugin,
      nativeTextTracks: !usePlugin,
    },
  };
}

export function toHlsSource(src) {
  if (src && typeof src === "object") {
    return src;
  }
  return {
    src,
    type: "application/x-mpegURL",
  };
}
